import { render } from "./DashGroupsSummary.vue?vue&type=template&id=ea408864&scoped=true&ts=true"
import script from "./DashGroupsSummary.vue?vue&type=script&lang=ts"
export * from "./DashGroupsSummary.vue?vue&type=script&lang=ts"

import "./DashGroupsSummary.vue?vue&type=style&index=0&id=ea408864&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea408864"]])

export default __exports__